import {FC, useMemo} from 'react'
import clsx from 'clsx'
import {KTIcon} from '../../../helpers'
import {HeaderUserMenu} from '../../../partials'
import {useLayout} from '../../core'
import {useAuth} from '../../../../app/modules/auth'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3'
const toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'

const getInitials = (value?: string) => {
  if (!value) return 'KP'
  const cleaned = value.trim()
  if (!cleaned) return 'KP'
  if (cleaned.includes('@')) {
    return cleaned.slice(0, 2).toUpperCase()
  }
  const parts = cleaned.split(/\s+/).filter(Boolean)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
}

const Topbar: FC = () => {
  const {config} = useLayout()
  const {currentUser} = useAuth()
  const label = currentUser?.firstName || currentUser?.email || 'Admin'
  const initials = useMemo(
    () => getInitials(currentUser?.firstName || currentUser?.email),
    [currentUser?.firstName, currentUser?.email]
  )

  return (
    <div className='d-flex align-items-stretch flex-shrink-0 me-5'>
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        <div
          className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <span className='kp-user-trigger'>
            <span className='kp-user-trigger-avatar'>{initials}</span>
            <span className='kp-user-trigger-label' title={label}>
              {label}
            </span>
            <i className='bi bi-chevron-down kp-user-trigger-caret'></i>
          </span>
        </div>
        <HeaderUserMenu />
      </div>

      {config.header.left === 'menu' && (
        <div className='d-flex align-items-center d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
            id='kt_header_menu_mobile_toggle'
          >
            <KTIcon iconName='text-align-left' className='fs-1' />
          </div>
        </div>
      )}
    </div>
  )
}

export {Topbar}
